export const Users = [
    {
        id:1,
        name:"Khushi Agarwal",
        username:"Khushi_20",
        profilePicture: "assets/person/person1.jpg"
    },
    {
        id:2,
        name:"Jiya",
        username:"Jiya_21",
        profilePicture:"assets/person/person2.jpg"
    },
    {
        id:3,
        name:"Riya Soni",
        username:"Riya_23",
        profilePicture:"assets/person/person3.jpg"
    },
    {
        id:4,
        name:"Suhani",
        username:"Suhani_22",
        profilePicture:"assets/person/person4.jpg"
    }
    // ,
    // {
    //     id:5,
    //     name:"Jenny",
    //     username:"Jenny_25",
    //     profilePicture:"assets/person/person5.jpg"
    // }
]

export const Posts = [
    {
        userId:4,
        id:1,
        body:"There is nothing more beautiful than a rainbow, but it takes both rain and sunshine to make a rainbow.",
        photo:"assets/post/post1.jpg",
        date:"8 mins ago",
        like:"105",
        comments:"35"
    },
    {
        userId:2,
        id:2,
        body:"Children are magic because they look for it.",
        photo:"assets/post/post2.jpg",
        date:"1 hour ago",
        like:"400",
        comments:"89"
    },
    {
        userId:1,
        id:3,
        body:"Drawing is an art of Expression",
        photo:"assets/post/post3.jpg",
        date:"10 hours ago",
        like:"800",
        comments:"150"
    },
    {
        userId:3,
        id:4,
        body:"Comment the Answer within 10 seconds",
        photo:"assets/post/post4.jpg",
        date:"15 hours ago",
        like:"500",
        comments:"350"
    },
    {
        userId:2,
        id:5,
        body:"Tell your parents to buy lots of chocolate for you ",
        photo:"assets/post/post5.jpg",
        date:"1 day ago",
        like:"500",
        comments:"350"
    },
    {
        userId:3,
        id:6,
        body:"Having Peace Time in lap of Mother Nature",
        photo:"assets/post/post6.jpg",
        date:"3 days ago",
        like:"750",
        comments:"300"
    },
    {
        userId : 1,
        id : 7,
        body : "Relief Time with Lime in Summers",
        photo:"assets/post/post7.jpg",
        date : "5 days ago",
        like : "600",
        comments : "100"
    },
    {
        userId:2,
        id:8,
        body:"Practising Calligraphy after almost year.",
        photo:"assets/post/post8.jpg",
        date:"7 days ago",
        like:"650",
        comments:"122"
    },
    {
        userId:4,
        id:9,
        body:"This is my new pet, isn't it cute ",
        photo:"assets/post/post9.jpg",
        date:"7 days ago",
        like:"700",
        comments:"200"
    }
]
export const UserOnline = [
    {
        id:1,
        name:"Narendra Modi",
        username:"Narendra_Modi_80",
        email:"narendra@example.com",
        profilePicture:"assets/user/user1.jpg"
    },
    {
        id:2,
        name:"Amit Shah",
        username:"Amit_Shah_55",
        email:"amit@example.com",
        profilePicture:"assets/user/user2.jpg"
    },
    {
        id:3,
        name:"Rahul Gandhi",
        username:"Rahul_50",
        email:"rahul@example.com",
        profilePicture:"assets/user/user3.jpg"
    },
    {
        id:4,
        name:"Kevin",
        username:"Kevin_28",
        email:"kevin@example.com",
        profilePicture:"assets/user/user4.jpg"
    },
    {
        id:5,
        name:"Rosie",
        username:"rosie_25",
        email:"rosie@example.com",
        profilePicture:"assets/user/user5.jpg"
    },
    {
        id:6,
        name:"Jasmine",
        username:"Jasmine_24",
        email:"jasmine@example.com",
        profilePicture:"assets/user/user6.jpg"
    },
    {
        id:7,
        name:"Harry",
        username:"Harry_28",
        email:"harry@example.com",
        profilePicture:"assets/user/user7.jpg"
    },
    {
        id:8,
        name:"Justin",
        username:"Justin_35",
        email:"justin@example.com",
        profilePicture:"assets/user/user8.jpg"
    },
    {
        id:9,
        name:"Charlie",
        username:"charlie_28",
        email:"charlie@example.com",
        profilePicture:"assets/user/user9.jpg"
    },
    {
        id:10,
        name:"James",
        username:"James_38",
        email:"james@example.com",
        profilePicture:"assets/user/user10.jpg"
    },
    {
        id:11,
        name:"Marie",
        username:"Marie_25",
        email:"marie@example.com",
        profilePicture:"assets/user/user11.jpg"
    },
    {
        id:12,
        name:"Sam",
        username:"Sam_22",
        email:"samabc@example.com",
        profilePicture:"assets/user/user12.jpg"
    },
    {
        id:13,
        name:"Taylor",
        username:"Taylor_35",
        email:"taylor@example.com",
        profilePicture:"assets/user/user13.jpg"
    },
    {
        id:14,
        name:"Selena",
        username:"Selena_30",
        email:"selena@example.com",
        profilePicture:"assets/user/user14.jpg"
    }
]